/**
 * YETKİ TANIMLARI
 *
 * Tek doğruluk kaynağı. Sunucu her isteği bu listeye göre denetler;
 * arayüz aynı listeyi yalnızca gereksiz butonu gizlemek için kullanır.
 * Arayüzde gizlemek yetkilendirme değildir — asıl kontrol sunucudadır.
 */
export const IZINLER = [
    // İş emri
    'is_emri.goruntule',
    'is_emri.olustur',
    'is_emri.duzenle',
    'is_emri.sil',
    // Müşteri & araç
    'musteri.goruntule',
    'musteri.duzenle',
    'musteri.sil',
    // Kasa
    'kasa.goruntule',
    'kasa.islem',
    'kasa.sil',
    /**
     * KASAYA KAYIT — defteri OKUMADAN girdi/çıktı yazabilme.
     *
     * `kasa.goruntule` yalnızca "listeyi aç" izni değildir: işletmenin
     * finansal durumunun kapısıdır (günlük/aylık gelir-gider, kasa
     * bakiyesi, ciro kutuları, Ana Sayfa finans paneli, müşteri cari
     * dökümü hep ona bakar). Personelin kasaya masraf/tahsilat yazabilmesi
     * için o kapıyı açmak gerekmesin diye bu DAR izin var:
     *   · Kasa ekranını açar, hareket listesini görür
     *   · Girdi/çıktı KAYDI oluşturur
     *   · Toplam/bakiye/ciro kutularını GÖRMEZ (onlar `kasa.goruntule`)
     *   · Kayıt düzenleyemez, silemez (`kasa.islem` / `kasa.sil`)
     */
    'kasa.kayit',
    'odeme.al',
    // Stok
    'stok.goruntule',
    'stok.duzenle',
    'stok.sil',
    /** Alış fiyatı ve stok değeri — kâr marjını ele verir, yöneticiye özel. */
    'stok.maliyet',
    // Fiyat kataloğu
    'fiyat.goruntule',
    'fiyat.duzenle',
    // Proforma
    'proforma.goruntule',
    'proforma.duzenle',
    // Araçlar
    'log.kullan',
    'post.kullan',
    // Yönetim
    'rapor.goruntule',
    'yonetim.kullanici',
    'yonetim.ayar',
    'yonetim.yedek',
    'yonetim.audit',
    'yonetim.cop',
];
export const ROLLER = ['yonetici', 'personel'];
/**
 * PERSONEL — günlük işini yapar, İŞLETMENİN FİNANSAL DURUMUNU GÖRMEZ.
 *
 * Yapabildikleri: iş emri açma ve yürütme, müşteri/araç kaydı, o iş emrinin
 * tutarını görüp ÖDEME ALMA, stok giriş-çıkışı, proforma kesme, fiyat
 * kataloğunu görüntüleme, Log Analiz ve Post Studio, kasaya girdi/çıktı
 * KAYDI (`kasa.kayit` — toplamları ve bakiyeyi görmeden).
 *
 * GÖREMEDİKLERİ — işletmenin mahrem bilgileri:
 *   · günlük/aylık gelir-gider toplamı, kasa bakiyesi, ciro
 *     (kasa.goruntule YOK — hareket YAZABİLİR ama defteri ÖZETLEYEMEZ)
 *   · alış fiyatı ve stok değeri — kâr marjı (stok.maliyet YOK)
 *   · cari hareket dökümü ve müşterinin toplam harcaması (kasa.goruntule YOK)
 *     — yalnızca müşterinin GÜNCEL BAKİYESİNİ görür, o da tezgâhta
 *       "ne kadar borcum var?" sorusuna cevap verebilmek için
 *   · raporlar, bekleyen alacaklar listesi (rapor.goruntule YOK)
 *   · kayıt silme, fiyat düzenleme, yönetim paneli
 *
 * Aldığı ödeme kasaya yazılır; artık masraf/tahsilatı da kendisi
 * yazabilir. Ama defterin ÖZETİNİ okuyamaz: para girer ve çıkar,
 * "bugün ne kadar kazandık" sorusunun cevabını yalnızca yönetici görür.
 *
 * Bu liste TEK doğruluk kaynağıdır: menü, ekran koruması ve her API ucu
 * aynı listeye bakar.
 */
const PERSONEL_IZINLERI = [
    'is_emri.goruntule',
    'is_emri.olustur',
    'is_emri.duzenle',
    'musteri.goruntule',
    'musteri.duzenle',
    'odeme.al',
    /* Kasaya girdi/çıktı yazar; toplam ve bakiye kutuları kapalı kalır. */
    'kasa.kayit',
    'stok.goruntule',
    'stok.duzenle',
    'fiyat.goruntule',
    'proforma.goruntule',
    'proforma.duzenle',
    'log.kullan',
    'post.kullan',
];
/**
 * Yalnızca yöneticide olan izinler — testler ve arayüz açıklamaları bunu
 * listeden türetir, elle ikinci bir liste tutulmaz.
 */
export function yoneticiyeOzelIzinler() {
    return IZINLER.filter((i) => !PERSONEL_IZINLERI.includes(i));
}
export const ROL_IZINLERI = {
    yonetici: IZINLER,
    personel: PERSONEL_IZINLERI,
};
export const ROL_ADI = {
    yonetici: 'Yönetici',
    personel: 'Personel',
};
export function rolIzinleri(rol) {
    return ROL_IZINLERI[rol] ?? [];
}
export function izinVarMi(rol, izin) {
    return rolIzinleri(rol).includes(izin);
}
export function gecerliRolMu(deger) {
    return typeof deger === 'string' && ROLLER.includes(deger);
}
//# sourceMappingURL=izinler.js.map